import React from 'react'
import { Link } from 'react-router-dom'
import { NotAvailable, Pill } from '@myxplor/ui'
import classnames from 'classnames'

import { conditionalLink } from '../../conditional-link'
import './personnel.css'

const validDob = (personnel_details) => (
  personnel_details && personnel_details.dob !== '0000-00-00'
)

const renderDob = ({ personnel_details }) => (
  <li>
    <dt title="Personnel Date of Birth">DOB</dt>
    <dd>
      {
        validDob(personnel_details) ?
          personnel_details.dob
          :
          <NotAvailable name="DOB" />
      }
    </dd>
  </li>
)

const createPills = ({ ccms_relationships = [] }) => (
  <div className="listItemContent--indicators">
    {
      ccms_relationships.map((relationship) => (
        <Pill key={relationship}>{relationship}</Pill>
      ))
    }
  </div>
)

const PersonnelRecord = ({ record, path, selected = false }) => (
  <div
    title={!record.active ? 'This record is inactive' : null}
    className={classnames({
      'listItemContent': false,
      'inactiveRecord': record.inactive
    })}
  >
    <div className="listItemContent personnel-list--wrapper">
      <div className="personnel-list--details">
        {
          conditionalLink(!selected,
            <Link to={path}>
              <div className="listItemContent--heading">
                {record.first_name} {record.last_name}
              </div>
            </Link>
          )
        }
        <dl className="listItemContent--details">
          {renderDob(record)}
        </dl>
      </div>

      {createPills(record)}

    </div>
  </div>
)

export default PersonnelRecord



// WEBPACK FOOTER //
// ./src/personnel/views/index.jsx